module.exports = __webpack_public_path__ + "img/primary_7x3_z18.eb69b14c.svg";